
const C_CONSTANT_NUMBER_OF_PICTURES = 50;
const C_CONSTANT_DOT_COMPLETION = 92;

const C_PHASE_CALIBRATING = 1;
const C_PHASE_PREPARE_SCAN_CHECK_CAMERA = 2;
const C_PHASE_PREPARE_SCAN_CHECK_FACE = 3;
const C_PHASE_PREPARE_SCAN_CHECK_POSITION = 4;
const C_PHASE_SCAN = 5;
const C_PHASE_START_SIZE = 6;  
const C_PHASE_PREPARE_SIZE_WAIT = 7;    
const C_PHASE_PREPARE_SIZE = 8;
const C_PHASE_SIZE = 9;
const C_PHASE_CLOSE_SIZE = 10;
const C_PHASE_CLOSING = 11;
const C_PHASE_RESTARTING = 12;
const C_PHASE_CONNECTED = 13;
const C_PHASE_CONNECTING = 14;  
const C_PHASE_PURCHASED = 15;  
const C_PHASE_NOTHING = 16;
const C_PHASE_ERROR = 17;  
const C_PHASE_CHECKOUT_IN_PROGRESS = 18;    
const C_PHASE_CHECKOUT_COMPLETED = 19;  
const C_PHASE_CHECKOUT_ABANDONNED = 20;

const C_FACE_NOSEPCT_X_MAX = 0.6;
const C_FACE_NOSEPCT_X_MIN = 0.4;
const C_FACE_NOSEPCT_Y_MAX = 1;
const C_FACE_NOSEPCT_Y_MIN = 0;
const C_FACE_WIDTHPCT_MAX = 0.9;
const C_FACE_WIDTHPCT_MIN = 0.7;
const C_FACE_WIDTHPCT_MIDDLE = ((C_FACE_WIDTHPCT_MAX-C_FACE_WIDTHPCT_MIN)/2+C_FACE_WIDTHPCT_MIN);

const C_FACE_ASPECT_RATIO = 1.8;
const C_FACE_YAW_MAX = 25;
const C_FACE_YAW_MIN = -25;  
const C_FACE_PITCH_MAX = 25;
const C_FACE_PITCH_MIN = -25;  

const C_FPS_LIMIT_MIN = 35; // was 35
const C_FPS_NUMBER = 25;
const C_FPS_LOW_WIDTH = 700;
const C_FPS_RESOLUTION = 0.75;

const C_SCAN_OPACITY = 0.5;

const C_CAMERA_ANALYSIS_NOT_STARTED = 1;
const C_CAMERA_ANALYSIS_STARTED = 2;
const C_CAMERA_ANALYSIS_COMPLETED = 3;
const C_CAMERA_ANALYSIS_ANALYZED = 4;

const C_UPLOADING_NOT_STARTED = 1;
const C_UPLOADING_IN_PROGRESS = 2;
const C_UPLOADING_COMPLETED = 3;
const C_UPLOADING_IN_ERROR = 4;
const C_PURPOSE_SCAN = 1;
const C_PURPOSE_PURCHASE = 2;
const C_REASON_NOTHING = "NOTHING";  
const C_REASON_NO_REASON = "NO_REASON";
const C_REASON_UPLOAD_ISSUES = "UPLOAD";
const C_REASON_PERFORMANCE_ISSUE1 = "PERFORMANCE1";
const C_REASON_PERFORMANCE_ISSUE2 = "PERFORMANCE2";
const C_REASON_PERFORMANCE_ISSUE3 = "PERFORMANCE3";
const C_REASON_ORDER_CONNECTED = "CONNECTED";
const C_REASON_ORDER_CREATED = "CREATED";  
const C_REASON_NO_COMMUNITATION = 'NOCOMMUNICATION';
  
const physicalScreenWidth = window.screen.availWidth;
const physicalScreenHeight = window.screen.availHeight;  
var initialScreenWidth = Math.round(window.screen.availWidth*C_FACE_WIDTHPCT_MIDDLE);
var initialScreenHeight = Math.round(window.screen.availHeight*0.70);

initialScreenHeight = Math.round(C_FACE_ASPECT_RATIO*initialScreenWidth); 
if (initialScreenHeight >  physicalScreenHeight) {
  const scale = physicalScreenHeight/initialScreenHeight*0.95;
  initialScreenHeight = scale*initialScreenHeight;
  initialScreenWidth = scale*initialScreenWidth;
}
var initialTop = Math.round(100*(physicalScreenHeight-initialScreenHeight)/physicalScreenHeight/4);
var initialLeft = Math.round(100*(physicalScreenWidth-initialScreenWidth)/physicalScreenWidth/2);
  
console.log("initialScreenHeight " + initialScreenHeight + " width: " + initialScreenWidth + " physicalScreenHeight:" + physicalScreenHeight + " inphysicalScreenWidth: " + physicalScreenWidth + " initialTop:" + initialTop + " initialLeft: " + initialLeft);
styleVAR = `
html {
  touch-action: pan-x pan-y;
}  
#msg,#video_canvas {
  height: 100%; 
  width: 100%; 
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
#facecanvas {
  height: 100vh; 
  width: 100vw; 
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(-1,1);
  -webkit-transform: scale(-1,1);
  -moz-transform:scale(-1,1);
}
#perf {
  position: absolute;
  top: 10%;
  left: 10%;
  width:80%;
  /*transform: translate(-50%, -50%);*/
  color: white;
  font-size: 3.2vh;
  text-align: center;
  text-shadow: 1px 1px 2px black;
  backdrop-filter: blur(10px);
  padding: 10px 10px 10px 10px;
  border: 2px;
  border-color: white;
  z-index: 100;
}
#fps {
  position: absolute;
  top: 2%;
  left: 7%;
  width:93%;
  /*transform: translate(-50%, -50%);*/
  color: white;
  font-size: 3.2vh;
  text-align: center;
  text-shadow: 1px 1px 2px black;
  backdrop-filter: blur(10px);
  padding: 10px 10px 10px 10px;
  border: 2px;
  border-color: white;
  z-index: 100;
}  
#action,#loadermsg {
  position: absolute;
  top: 0%;
  left: 0%;
  width:100%;
  depth:50%;
  /*transform: translate(-50%, -50%);*/
  color: white;
  font-size: 3.2vh;
  text-align: center;
  text-shadow: 1px 1px 2px black;
  backdrop-filter: blur(10px);
  padding: 10px 10px 10px 10px;
  border: 2px;
  border-color: white;
  z-index: 100;
}
#counter,#loadercounter {
  position: absolute;
  top: 40%;
  left: 0%;
  width:100%;
  depth:100%;
  /*transform: translate(-50%, -50%);*/
  color: white;
  font-size: 7.2vh;
  text-align: center;
  text-shadow: 1px 1px 2px black;
  backdrop-filter: blur(10px);
  padding: 10px 10px 10px 10px;
  border: 2px;
  border-color: white;
  z-index: 100;
}
#loadercounter {
  top: 40%;
}
#loadermsg {
  top: 10%;
}
#hole {
  position: absolute;
  top: ${initialTop}%;
  left: ${initialLeft}%;
  width: ${initialScreenWidth}px;
  height: ${initialScreenHeight}px;
  border-radius: 50%;
  background-color: transparent;
  color: transparent;
  -webkit-appearance: none;
  box-shadow: 0 0 0 9999px rgba(128,128,128, 0.5);
  -webkit-box-shadow: 0 0 0 9999px rgba(128,128,128, 0.5);
  -moz-box-shadow: 0 0 0 9999px rgba(128,128,128, 0.5);
  transition: box-shadow ease 0.8s;  
}

#upbow {
  position: absolute;
  width: ${initialScreenWidth}px; 
  height: 1px; 
  top: 40%;
  left: 0px;
  border: solid 5px #000;
  border-color: #000 transparent transparent transparent;
  border-radius: 70%/1px 1px 0 0;
}

#holed {
    background-color: #45597e;
    height: 75%;
    width: 80%;
    top: 7%;
    left: 10%;
    border-radius: 50%;
}  
.container {
  top: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20%;
  width: 100%;
  z-index: 100;
}

.progress-bar__container {
  width: 80%;
  height: 2rem;
  border-radius: 2rem;
  position: relative;
  overflow: hidden;
  transition: all 0.5s;
  will-change: transform;
  box-shadow: 0 0 5px #4895ef;
  z-index: 101;
}

.progress-bar {
  position: absolute;
  height: 100%;
  width: 100%;
  content: "";
  background-color: #4895ef;
  top:0;
  bottom: 0;
  left: -100%;
  border-radius: inherit;
  display: flex;
  justify-content: center;
  align-items:center;
  color: white;
  font-family: sans-serif;
  z-index: 102;
}

.progress-bar__text {
  display: none;
}
#sizingcontinue {
  position: absolute;
  z-index: 20000;
  top: 80%;
  left: 50%;
  background-color: #000;
  border: 1.5px solid #000;
  padding: 14px 16px;
  color: #fff;
  display: block;
  font-weight: 700;
  margin: 0 auto;
  font-size: 13px;
  letter-spacing: 3.8px;
  transition: all .2s;
  width: 60%;
  max-width: 360px;
  transform: translate(-50%, -50%);
}
#againcontinue {
  position: absolute;
  z-index: 20000;
  top: 80%;
  left: 20%;
  background-color: #000;
  border: 1.5px solid #000;
  padding: 14px 16px;
  color: #fff;
  display: block;
  font-weight: 700;
  margin: 0 auto;
  font-size: 13px;
  letter-spacing: 3.8px;
  transition: all .2s;
  width: 60%;
  max-width: 360px;
}
.closeScan{
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 10;
} 
@keyframes move-eye-skew {
  0% {
    transform: none;
  }
  20% {
    transform: translateX(-68px) translateY(30px) skewX(15deg) skewY(-10deg) scale(0.95);
    transform: scaleY(1.5) scaleX(0.90);
  }
  25%, 44% {
    transform: none;
  }
  50%, 60% {
    transform: translateX(68px) translateY(-40px) skewX(5deg) skewY(2deg) scaleX(0.95);
  }
  66%, 100% {
    transform: none;
  }
}

#ball {
  display: block;
  position: absolute;
  top: 7%;
  left: 10%;  
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 50%;
  position: relative;
  background: radial-gradient(circle at 50% 50%, rgba(252,252,252,0.3), rgba(239,239,241,0.3) 66%, rgba(155,80,80,0.3) 100%);
}
#ball:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8) 14%, rgba(255, 255, 255, 0) 24%);
  transition: transform ease 0.3s;  
}

#iris {
  width: 40%;
  height: 40%;
  margin: 30%;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 50%, #208ab4 0%, #6fbfff 30%, #4381b2 100%);
  /*transform: translateX(68px) translateY(-60px) skewX(15deg) skewY(2deg);*/
  position: absolute;
  /* animation: move-eye-skew 5s ease-out infinite;*/
}
#iris:before {
  content: "";
  display: block;
  position: absolute;
  width: 37.5%;
  height: 37.5%;
  border-radius: 50%;
  top: 31.25%;
  left: 31.25%;
  background: black;
}
#iris:after {
  content: "";
  display: block;
  position: absolute;
  width: 31.25%;
  height: 31.25%;
  border-radius: 50%;
  top: 18.75%;
  left: 18.75%;
  background: rgba(255, 255, 255, 0.2);
}

#ball #shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0) 50%);
  transform: rotateX(90deg) translateZ(-150px);
  z-index: -1;
}
#stage {
  width: ${initialScreenWidth}px;
  height: ${initialScreenHeight}px;
  display: block;
  perspective: 1200px;
  perspective-origin: 50% 50%;
  transform-style: preserve-3d;
  transform: rotateY(0.01deg);
}
`;
 
const injectCSS = css => {
  let el = document.createElement('style');
  el.type = 'text/css';
  el.innerText = css;
  document.head.appendChild(el);
  return el;
};  
injectCSS(styleVAR);
var canvas;
var ctx;
var gl;
var modal;
var modalScan;
var modalAlert;
var modalLoader;  
var modalOrder;
var modalProducts;
var modalScanOptions;
var modalStartScan;
var modalStepTwo;
var modalStepOne; 
var modelStepLinked;
var modelReferral;
var stepOneComplete;
var stepTwoComplete;
var formOrder;  
var oneScan;
var variousScan;
var closeScan;
var checkoutHandle = null;
var contextLostError = false;
  
var language = navigator.language.substr(0,2);
var UUID = getUUID();
var secret = getSecret();
var reloadReason = '';
var urlSearchParams = new URLSearchParams(window.location.search);
var curr_page = window.location.href;
var phone_type = navigator.platform;
var facingMode = 'environment';
var containedInScanApp = '0';
var executingScanApp = '1';
var testing = false;

document.addEventListener("DOMContentLoaded", function(){
    const modal = document.getElementById('myModal');
    const modalBIPA = modal;
    const modalQR = document.getElementById('ModalQR');  
    modalAlert = document.getElementById('ModalAlert'); 
    modalStepLinked = document.getElementById('modalStepLinked'); 
    modalReferral = document.getElementById('modalReferral'); 
    const modalTurn = document.getElementById('ModalTurn'); 
    const modalOld = document.getElementById('ModalOld');   
    modalScan = document.getElementById("ModalScanOrder");
    modalLoader = document.getElementById("ModalLoader");
    modalScanOptions = document.getElementById("ModalScanOptions");
    const linkScan = document.querySelector(".button_alert.scan");
    const tryScan = document.querySelector(".button_alert2.scan");
    const doneButton = document.getElementById("doneButton");
    oneScan = document.getElementById("OneScan");
    variousScan = document.getElementById("VariousScan");
    const modalGetStarted = document.getElementById("ModalGetStarted");
    const getStarted = document.getElementById("getStarted");
    modalStepOne = document.getElementById("ModalStepOne");
    const gotIt = document.getElementById('gotIt');
    const modalSlider = document.getElementById("ModalSlider");
    modalStartScan = document.getElementById("ModalStartScan");
    stepOneComplete = document.getElementById("StepOneComplete");
    const startScan = document.getElementById('startScan');
    const actualScan = document.querySelector(".Scan-modalCamera");
    modalStepTwo = document.getElementById("ModalStepTwo");
    const modalCreditCard = document.getElementById("ModalCreditCard");
    const gotIt2 = document.getElementById('gotIt2');
    const startSecond = document.getElementById('startSecond');
    stepTwoComplete = document.getElementById("StepTwoComplete");
    formOrder = document.getElementById('order');
    modalOrder = document.getElementById('ModalOrder');
    modalProducts = document.getElementById('ModalProducts');  

    // When the user clicks on OK button, close the modal
    document.getElementById('okButton').addEventListener("click", ()=> modalBIPA.style.display = "none");
    document.querySelector('.close').addEventListener("click", ()=> modalStepOne.style.display = "none");
    document.querySelector('.closeOrder').addEventListener("click", ()=> {
      modalOrder.style.display = "none";
    });
    document.querySelector('.closeProducts').addEventListener("click", ()=> {
      reloadURL(C_REASON_NO_REASON,"",0);
    });  
    document.getElementById('turnPhoneOkButton').addEventListener("click", ()=> {
      reloadURL(C_REASON_NO_REASON,"",0);
    });    
    //closeScanReceived.addEventListener("click", ()=> scanReceived.style.display = "none");

    // When the user loads the page, open the modal

    linkScan.addEventListener("click", ()=>{
        modalScan.style.display = "block";
        modalScan.style.zoom = '100%';
    })
    formOrder.addEventListener("submit", (e)=>{
        e.preventDefault();
        showOrders();
    })
    formOrder.addEventListener("reset", (e)=>{
        modalScan.style.display = "none";
        e.preventDefault();
    })  
    tryScan.addEventListener("click", ()=>{
        // modalGetStarted.style.display = "block";
        modalStepOne.style.display = "block"; 
        //sendAppMessage("ASKFORREVIEW");
        log("Scan process: Started - Try ","E");
    })
    oneScan.addEventListener("click", ()=>{
        order_id = oneScan.getAttribute('order_id');
        modalScanOptions.style.display = "none";
        modalStepOne.style.display = "block";
        log("Scan process: Intro - One scan order: " + order_id,"E");
    })
    variousScan.addEventListener("click", ()=>{
        order_id = variousScan.getAttribute('order_id');
        modalScanOptions.style.display = "none";
        modalStepOne.style.display = "block";
        log("Scan process: Intro - Various scans order: " + order_id,"E");      
    })
    getStarted.addEventListener("click", ()=>{
        modalGetStarted.style.display = "none";
        modalStepOne.style.display = "block";
        log("Scan process: Intro - Single scan order: " + order_id,"E");
    })
    gotIt.addEventListener("click", ()=>{
        modalStepOne.style.display = "none";
        modalSlider.style.display = "block";
        var elem = document.querySelector('#ModalSlider.main-carousel.modal-sliderAll');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true
        });
        flkty.on( 'scroll', function( progress ) {
            let str = document.querySelector('#ModalSlider .flickity-slider').style.transform;
            let matches = str.match(/\d+/g);
            /*if(matches[1] > 320){
                actualScan.style.display = "block";      
                modalStartScan.style.display = "none";
                modalSlider.style.display = "none";   
                phase = C_PHASE_CALIBRATING;
                main();
            }
            if(document.querySelector("#ModalSlider .flickity-prev-next-button.next[disabled]")){
                document.querySelector("#ModalSlider .flickity-prev-next-button.next[disabled]").addEventListener("click", ()=>{
                    modalSlider.style.display = "none";
                    actualScan.style.display = "block";      
                    modalStartScan.style.display = "none";  
                    phase = C_PHASE_CALIBRATING;
                    log("Scan process: Started: " + order_id,"E");
                    main();
                })
            }*/
        });
    })
    startScan.addEventListener("click", ()=>{
        actualScan.style.display = "block";      
        modalStartScan.style.display = "none";
        modalSlider.style.display = "none";   
        phase = C_PHASE_CALIBRATING;
        log("Scan process: Started: " + order_id,"E");
        main();
    })
    gotIt2.addEventListener("click", ()=>{
        modalStepTwo.style.display = "none";
        modalCreditCard.style.display = "block";
    })
    startSecond.addEventListener("click", ()=>{
        modalCreditCard.style.display = "none"
        phase = C_PHASE_START_SIZE;
    })
    closeScan = document.getElementById("closeScan");  
    closeScan.addEventListener("click", ()=>{
        reloadURL(C_REASON_NO_REASON,"",0);
    }) ;
    //window.onload = function() {
    window.addEventListener('load', function() {     
      if (language === undefined) {
        modalOld.style.display = "block";          
      } else if (window.orientation === undefined) {
        modalQR.style.display = "block";  
        var qrcode = new QRCode(document.getElementById("qrcode"), {
          text: window.location.href,
          width: 200,
          height: 200,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : QRCode.CorrectLevel.H
        });
        blocked = true;
      } else if (window.orientation != 0 ) {
        modalTurn.style.display = "block";
      } else if (reloadReason == C_REASON_ORDER_CONNECTED && sessionStorage.getItem("email") != '' ) {
        email = sessionStorage.getItem("email");
        showOrders(email);
      } else if (urlSearchParams.get('email') != null) {
        email = urlSearchParams.get('email');
        showOrders(email);
      } else if (urlSearchParams.get('order_id') != null) {
        order_id = urlSearchParams.get('order_id');
        urlSearchParams.delete('order_id');
        actualScan.style.display = "block";      
        modalStartScan.style.display = "none";
        modalSlider.style.display = "none";   
        phase = C_PHASE_CALIBRATING;
        main();
      } else if (sessionStorage.getItem("checkoutPurpose") == 'thank_you_webapp') {
        sessionStorage.removeItem("checkoutPurpose");
        email = sessionStorage.getItem("email");
        XXXorder_id = urlSearchParams.get('order_id');
        urlSearchParams.delete('order_id');
        actualScan.style.display = "block";      
        modalStartScan.style.display = "none";
        modalSlider.style.display = "none";   
        phase = C_PHASE_CALIBRATING;
        main();
      } else if (reloadReason == C_REASON_PERFORMANCE_ISSUE1) {
        actualScan.style.display = "block";      
        modalStartScan.style.display = "none";
        modalSlider.style.display = "none";   
        phase = C_PHASE_CALIBRATING;
        main();        
      } else if (reloadReason != '') {
        actualScan.style.display = "block";      
        modalStartScan.style.display = "none";
        modalSlider.style.display = "none";   
        phase = C_PHASE_CALIBRATING;
        main();
      } else if (urlSearchParams.get('test') != null) {
        testing = true;
        //order_id = '264786';
        //showLinked();

      } else {
        //if (sessionStorage.getItem("shownBIPA") == '1') {
          modal.style.display = "block"; 
          sessionStorage.setItem("shownBIPA","1");
          log("BIPA shown","BIPA","BIPA");
        //}
      }  
      document.getElementById('introvideo').play();
    });


});
  
  
    var purpose;
    var cameraAnalysis;
    var cameraAnalysisStatus = C_CAMERA_ANALYSIS_NOT_STARTED;
    var phase = C_PHASE_CALIBRATING;
    var nextMessage = '';
    var numberOfRestarts = 0;
    var getSizeInScanning = true;
    var uploadingStatus = C_UPLOADING_NOT_STARTED;
    var numberOfUploads = 0;
    var numberOfUploadsInitiated = 0;
    var SCAN_id = '';
    var order_id = '';
    var order_ids = '';
    var shopify_order_number = '';
    var email = ''; 
    var resolution = C_FPS_RESOLUTION;
    var globalCompletion = 0;
    var countDownInitializationStopIndicator = false;
    var globalDebug = false;
    var videoWidth;
    var videoHeight;
    var pictureHeight;
    var pictureWidth;
    var inScanningLoop = true;
    var holeColor = 'GREY';
    var irisX = 0;
    var irisY = 0;

    var fpssum = 25;
    var fpsnum = 0;
    var console = window.console;
    var url = 'https://themagic5.com/tools/appconnect';
    var LEFT_EYE = 33;
    var RIGHT_EYE = 263;
    var threads = 10;
    var token = '';
    var scanningInProgress = false;
    var mesh_color = Array(468);
    var mesh_section = Array();
    var image_array = Array();    
    var image_upload_status = Array();
    var image_upload_retried = false;
    var landmark_array = Array();
    var scaledlandmark_array = Array();
    var closed = false;
    var screenHeight = window.screen.availHeight*window.devicePixelRatio;
    var screenWidth = window.screen.availWidth*window.devicePixelRatio;
    let cv;
  
    var pageAccessedByReload = (
      (window.performance.navigation && window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType('navigation')
          .map((nav) => nav.type)
          .includes('reload')
    );
    if (urlSearchParams.get('token') != null) {
      UUID = urlSearchParams.get('token');
    }
    if (urlSearchParams.get('reason') != null) {
      reloadReason = urlSearchParams.get('reason');
      urlSearchParams.delete("reason");
      if (reloadReason != '') {
        pageAccessedByReload = true;
      }
    } 
    if (urlSearchParams.get('facingMode') != null) {
      facingMode = urlSearchParams.get('facingMode');      
    } 
    if (urlSearchParams.get('executingPhoneApp') == '1') {
      sessionStorage.setItem('executingEnvironment', 'App');
    } else {
      sessionStorage.setItem("executingEnvironment","Web");
    }
    if (urlSearchParams.get('resolution') != null) {
      resolution = urlSearchParams.get('resolution');
    } 

    if (window.location.search.length > 0) {
      curr_page = window.location.href.substr(0,window.location.href.indexOf(window.location.search));
      urlSearchParams.delete('reason');
      if (urlSearchParams.toString().length > 0) {
        curr_page = curr_page + '?' + urlSearchParams.toString();
      }  
    }

    
    log("Scan App initiated with email " + email + " and token " + token + " and reason " + reloadReason + " Query: " +  + urlSearchParams.toString());

    pictureHeight = screenHeight*resolution;
    pictureWidth = screenWidth*resolution;  

  function getUUID() {    
      let machineId = localStorage.getItem('UUID');    
      if (!machineId) {   
        if (crypto.randomUUID === undefined) {
          machineId = Math.random().toString(20).toString('hex')          
        } else {
          machineId = crypto.randomUUID();
        }
        localStorage.setItem('UUID', machineId);
      }
      return machineId;
  }
  function setUUID(uuid) {
    UUID = uuid;
    localStorage.setItem('UUID', UUID);
    sendAppMessage("setUUIDCompleted");
  }
  
  async function onOpenCvReady() {
    log("DEBUG OpenCV is ready");
    cv = window.cv;
  }  
  async function setupCamera() {
    video = document.getElementById('video');
    const stream = await navigator.mediaDevices.getUserMedia({
      'audio': false,
      'video': {
        facingMode: facingMode, // 'environment',
        width: pictureHeight, // {ideal: 630}, // 1920     1280*1.2, 
        height: pictureWidth // {ideal: 1200}, // 1080    720*1.2
      },
    });
    video.srcObject = stream;
    let {width, height} = stream.getTracks()[0].getSettings();
    
    log(`Dimension analysis: Video: (${pictureWidth},${pictureHeight},${pictureHeight/pictureWidth}) Screen: (${screenWidth},${screenHeight},${screenHeight/screenWidth}) inputVideo: (${width},${height},${height/width}) `,'E');
    return new Promise((resolve) => {
      video.onloadedmetadata = () => {
        resolve(video);
      };
    });
  
  }
  
  var HttpClient = function() {
      this.get = function(aUrl, aCallback) {
          var anHttpRequest = new XMLHttpRequest();
          anHttpRequest.onreadystatechange = function() { 
              if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
                  aCallback(anHttpRequest.responseText);
              if (anHttpRequest.status != 200) 
                  log("Callclient: " + aUrl + "-" + anHttpRequest.status + "-" + anHttpRequest.responseText);
          }
  
          anHttpRequest.open( "GET", aUrl, true );            
          anHttpRequest.send( null );
      }
      this.post = function(aUrl, postvar, aCallback) {
          var anHttpRequest = new XMLHttpRequest();
          anHttpRequest.onreadystatechange = function() { 
              if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
                  aCallback(anHttpRequest.responseText);
          }
          anHttpRequest.open( "POST", aUrl, true );            
          anHttpRequest.send( postvar );
      }
  }
  async function getSecret() {
    $.ajax({
      url:`https://themagic5.com/tools/appconnect/authenticate.php?unique_id=${UUID}`,
      method: 'GET',
      success: function(data){
        if(data){
          if (data.status == 'Success') {
            secret = data.secret;
          }
        } else {
          log(`Was not able to retrieve the secret from the server. Error: $(error)`,"E");
          showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);
          
        }
      },
      error: function(data) {
        log(`Was not able to retrieve the secret from the server. Error: $(error)`,"E");
        showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);
      }
    });
    
  }
  async function initialize() {
    console.log(order_id);
      const formData = new FormData();
      formData.append('UUID',getUUID());
      formData.append('secret',secret);    
      formData.append('first_order_id',order_id);
      formData.append('language',language);
      formData.append('phonetype',phone_type + " web");    
      const options = {
          method: 'POST',
          body: formData,
        };
      fetch(url + '/initialize.php', options).then((response) => {
        if (response.status == 200) {
          return response.text();
        }
        throw new Error('1');
      })
      .then((responseText) => {
        token = responseText;
        console.log(token);
        if (token == 'Index does not exist') {
          log(`Was not able to initialize. Error: $(error)`,"E");
          showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);      
        } else {
          scanningInProgress = true;
        }          

        return(true);      
      })      
      .catch((error) => {
        log(`Was not able to initialize. Error: $(error)`,"E");
        showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0); 
      });    
  }
  async function close() {
    scanningInProgress = false;
    if (closed == false) {
      const formData = new FormData();
      formData.append('token',token);
      formData.append('UUID',getUUID());        
      formData.append('secret',secret);
      const options = {
          method: 'POST',
          body: formData,
        };
      fetch(url + '/close.php', options).then((response) => {
        if (response.status == 200) {
          return response.text();
        }
        throw new Error('1');
      })
      .then((responseText) => {
        if (isJson(responseText)) {
          return(JSON.parse(responseText));
        }
        throw new Error('2');        
      })
      .then((arr) => {  
        if (arr['Status'] == 'OK') {
          uploadingStatus = C_UPLOADING_COMPLETED;
        }  else {
          log(`Was not able to close scan. Error: $(error)`,"E");
          showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);         
        }    
        return(true);      
      })      
      .catch((error) => {
        log(`Was not able to close scan. Error: $(error)`,"E");
        showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);
      });  
    }
  }  
  
  async function updateOrderWithScanID() {
      aUrl = url + '/appconnect.php?secret=' + secret + '&order_id=' + order_id + '&scan_id=' + SCAN_id + '&task=updateOrderWithScanID';    
      var client = new HttpClient(aUrl);
      client.get(aUrl, function(response) {
        if (isJson(response)) {
          arr = JSON.parse(response);
          if (arr['data']['status'] == 'Success') {
            phase = C_PHASE_CONNECTED;            
          } else {
            log(`Was not able to connect the scan to the order. Error: $(error)`,"E");
            showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0);
            phase = C_PHASE_ERROR;
          }
        }
      });
  }    
  async function sendImage(image,mesh,i,aCallback) {
      image_upload_status[i] = {'i': i, 'started': true, 'completed': false, 'error': false,'errmsg': '' };  
      numberOfUploadsInitiated += 1;
      const formData = new FormData();
      formData.append('file', image,"file");
      formData.append('secret', secret);
      formData.append('RIGHT_EYE_OUTER_CORNER_X', mesh[265][0]);
      formData.append('token',token);
      formData.append('UUID',getUUID());      
      formData.append('norotate','1');
      formData.append('PICTURENUMBER',i);
      formData.append('PHONE_TYPE',phone_type + " web");  
      if (getSizeInScanning == false && i == 0) {
        formData.append('HEADSIZE',(-1*cameraAnalysis['headsize']));
        formData.append('SIZEPICTURE','YES');        
      }
      //formData.append('obj',createObj(i));  
      //formData.append('ZIPPED_FILE','YES');
      const options = {
          method: 'POST',
          body: formData,
        };
      let arr;
      fetch(url + '/receive.php', options).then((response) => {
        //console.log(response);
        if (response.status == 200) {
          return response.text();
        }
        if (typeof response.text() !== 'undefined') {
          throw new Error('1: ' + response.text());
        } else {
          throw new Error('1: ' + response);          
        }
      })
      .then((responseText) => {
        //console.log(responseText);
        if (isJson(responseText)) {
          return(JSON.parse(responseText));
        }
        throw new Error('2: ' + responseText);        
      })
      .then((arr) => {
        numberOfUploads += 1;
        image_upload_status[i] = {'i': i, 'started': true, 'completed': true, 'error': false,'errmsg': '' };  
        SCAN_id = arr['SCAN_id'];
        console.log("Number of uploads " + numberOfUploads + " And threads " + threads + " image array length " + image_array.length);
        if (image_array.length-1 > i+threads) {
            sendImage(image_array[i+threads],scaledlandmark_array[i+threads],i+threads,function(data) {
                log(" - Successfully send image number: " + i+threads);
            });
        } else {
            if (numberOfUploads == image_array.length-1 && closed == false) { 
                uploadStatus = C_UPLOADING_COMPLETED;
                close();
            }
        }            

        return(true);      
      })      
      .catch((error) => {
        image_upload_status[i] = {'i': i, 'started': true, 'completed': false, 'error': true,'errmsg': error }; 
        analyzeUploads();
        //console.log(error);
      });
  } 
  async function analyzeUploads() {
    var uploads_in_progress = 0;
    var number_of_errors = 0;
    for (let i = 0; i < image_array.length; i++) { 
       if (image_upload_status[i] != null) {
          var status = image_upload_status[i];
          if (status['started'] && status['completed'] == false && status['error'] == false) {
            uploads_in_progress += 1;
          }
          if (status['error'] == true) {
            number_of_errors += 1;
          }         
       }
    }
    var baseNotUploaded = false;
    if (image_upload_status[0] != null) {
      if (image_upload_status[0]['error'] == true) {
        baseNotUploaded = true;        
      }
    }  
    log("Analysis in progress - Progress " + uploads_in_progress + " error " + number_of_errors);
    
    if (number_of_errors > 0 && uploads_in_progress > 0) {
      setTimeout(function() {
          console.log("Retrying");
          analyzeUploads();
      }, 1000); 
    }
    if ((number_of_errors > 10 || baseNotUploaded) && uploads_in_progress == 0 && image_upload_retried) {
      alert(trans("scan.alert.scanfailedfrominternet"));
      var uploadmsg = '';
      for (let i = 0; i < image_upload_status.length; i++) {   
        uploadmsg = uploadmsg + 'I: ' + i + "{" + image_upload_status[i].errmsg + "},";
      }
      log("Upload errors. " + uploadmsg,'E');
      reloadURL(C_REASON_NOTHING, "Upload issues",0);  
    } 
    if (number_of_errors <= 10 && uploads_in_progress == 0 && image_upload_retried) {
      uploadStatus = C_UPLOADING_COMPLETED;
      close();  
    }     
    if (number_of_errors > 0 && uploads_in_progress == 0 && image_upload_retried == false) {
      for (let i = 0; i < image_array.length; i++) { 
        if (image_upload_status[i] != null) {
          var status = image_upload_status[i];
          if (status['error']) {
            log("Re-uploading image " + i + " not using threads.")
            image_upload_retried = true;
            sendImage(image_array[i],scaledlandmark_array[i],i+threads,function(data) {
              log("I did try to re-send image: " + i);
            });
          }
        }
      }
    }  
    log("Analysis completed - Progress " + uploads_in_progress + " error " + number_of_errors);
  }
  async function sendSizingImage(image,aCallback) {
      if (numberOfUploads > 0) {
      var headsize = 0;
      if (cameraAnalysis['headsize'] > 0) {
        headsize = cameraAnalysis['headsize'];
      }
      const formData = new FormData();
      formData.append('file', image,"file");
      formData.append('token',token);
      formData.append('secret',secret);        
      formData.append('norotate','1');
      formData.append('UUID',getUUID());  
      formData.append('LENSPOSITION','0');
      formData.append('SCAN_id','');
      formData.append('PHONE_TYPE',phone_type + " web");
      formData.append('LEFT_EYE_OUTER_CORNER_X','0');
      formData.append('LEFT_EYE_OUTER_CORNER_Y','0');
      formData.append('RIGHT_EYE_OUTER_CORNER_X','0');
      formData.append('RIGHT_EYE_OUTER_CORNER_Y','0');
      formData.append('LEFT_CREDITCARD_UPPER_X','0');
      formData.append('LEFT_CREDITCARD_UPPER_Y','0');
      formData.append('RIGHT_CREDITCARD_UPPER_X','0');
      formData.append('RIGHT_CREDITCARD_UPPER_Y','0');
      formData.append('HEADSIZE',headsize);
      formData.append('YAW','0');
      formData.append('PITCH','0');
      formData.append('ROLL','0');
    
      const options = {
          method: 'POST',
          body: formData,
        };
      let arr; 
      var response = await fetch(url + '/receivesize.php', options);
      if (response.status == 200) {
        let ret = response.text();
        var success = await ret.then((result) => {
          if (isJson(result)) {
            arr = JSON.parse(result);
            if (arr['Status'] == 'OK') {
              phase = C_PHASE_CLOSING;
              return(true);
            } 
          }
          log("Error when uploading with sizing image with message: " + result,'W');  
          return(false);
        }); 
      }
    } else {
      setTimeout(function() {
        log("Waiting to send sizing image");
        sendSizingImage(image,function(data) {
          log("Sizing image has been send and completed successfully.");
        });
      }, 2000);       
    }
  } 
  function addMessage(message,code,addmsg) {
    console.log(code + addmsg);
    message = message + ' ' + trans(code,addmsg);
    return(message);
  }
  async function checkCamera(image,aCallback) {
      const formData = new FormData();
      formData.append('file', image,"file");
      formData.append('UUID',getUUID());  
      formData.append('secret',secret); 
      formData.append('token',token);
      formData.append('norotate','1');
      const options = {
          method: 'POST',
          body: formData,
        };
      let arr;
    
      var response = await fetch(url + '/checkimage.php', options);
      if (response.status == 200) {
        let ret = response.text();
        var success = await ret.then((result) => {
          if (isJson(result)) {
            arr = JSON.parse(result);
            if (arr['Status'] == 'OK') {
              cameraAnalysis = arr;
              var message = '';
              if (arr['NoFace'] != '1') {
                if (cameraAnalysis['Glasses'] == true) {
                  message = addMessage(message,"scan.message.glasses","You are wearing glasses. Please remove your glasses and restart.");
                } else if (cameraAnalysis['Brightness'] < 50) {
                  message = addMessage(message,"scan.message.darkenvironment","Your environment is too dark. Please move to a room with more of ambient light.");
                } else if (cameraAnalysis['Sharpness'] < 50) {
                  message = addMessage(message,"scan.message.notclear","Your camera lense is not clear. Please clean.");
                } else if (cameraAnalysis['Emotions']['SURPRISED'] > 50) {
                  message = addMessage(message,"scan.message.surprised","Please look surprised in order to the scan to be super good.");
                }
                /* Disabled in the production environment because opencv load takes a very long time, and because
                 * we have not been able to determine the correct threshold.
                if (hasStrongLightBackground()) {
                  message = addMessage(message, "Move to an area with less direct background light.");              
                } */
              }
              if (message != '') {
                  cleanup();
                  phase = C_PHASE_NOTHING;
                  showMessage(message);
                  document.getElementById("againdiv").style.visibility="visible";
              }
              if (cameraAnalysis['headsize'] > 0) {
                getSizeInScanning = false;
              }
              cameraAnalysisStatus = C_CAMERA_ANALYSIS_ANALYZED;
              return(true);
            } 
          }
          log("Cameracheck ended in error: " + result,'W');  
          return(false);
        }); 
      }
  }
  function restartScan() {
    cleanup();
    phase = C_PHASE_CALIBRATING;
    document.getElementById("againdiv").style.visibility="hidden";
  }
  function prepareMessage(text) {
    nextMessage = text;
  }
  function isJson(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
  }
  
  // Calls face mesh on the video and outputs the eyes and face bounding boxes to global vars
  var curFaces = [];
  async function renderPrediction() {
      now = performance.now();
      const facepred = await fmesh.estimateFaces(video);
    
      if (facepred.length > 0) { // If we find a face, process it
        curFaces = facepred;
      } else {
        showMessage("scan.message.showface","Position your face in front of your phone");
        if (phase == C_PHASE_CALIBRATING) {
          document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.showface","Position your face in front of your phone") + "</p>";
        }
      }
      if (inScanningLoop) {
        requestAnimationFrame(renderPrediction);             
      }
  };
  
  
  async function drawVideo(){
    var completion;
    ctx.drawImage(video, 0, 0);
    for (face of curFaces){
      if (face.faceInViewConfidence > .95) {
        completion = drawFace(face); 
      } 
    } 
    // console.log("completion " + globalCompletion);
    if (scanningInProgress) {
      
      if (image_array.length >= C_CONSTANT_NUMBER_OF_PICTURES || globalCompletion > C_CONSTANT_DOT_COMPLETION) {
        scanningInProgress = false;
        // getSizeInScanning = true;
        if (getSizeInScanning) {
          phase = C_PHASE_PREPARE_SIZE;
          showMessage("scan.message.finishedstartcredit","Scanning process is finished. Next phase: Get a credit card sized card, and put it on your forehead."); 
        } else {
          phase = C_PHASE_CLOSING;
          showMessage("scan.message.finished","Scanning process is finished."); 
        }
        uploadingStatus = C_UPLOADING_IN_PROGRESS;
        var n = 0;
        for (let i = 0; i < threads; i+=1) {
            n = i;
            log("UPLOAD: Initiating thread " + i);
            sendImage(image_array[n],scaledlandmark_array[n],i,function(data) {
                log(" - Image has now been transferred.");
            });
        }
        log("Scan process: Completed: " + order_id,"E");
      }
    }
    if (inScanningLoop) {
      requestAnimationFrame(drawVideo); 
    }
  }  

  function getSection(face) {
       yaw_max = 40;
       pitch_max = 45;
       yaw = face.mesh[LEFT_EYE][2] - face.mesh[RIGHT_EYE][2];
       pitch = face.mesh[200][2] - face.mesh[151][2];
       middle = face.mesh[4];
       left_outer = face.mesh[227];
       right_outer = face.mesh[447];
       lower = face.mesh[152];
       upper = face.mesh[10];
       height = (upper[1] - middle[1]);
       if (yaw > 0) {
           width = (right_outer[0] - middle[0]);
       } else {
           width = (middle[0] - left_outer[0]);
       }
       
       x = (yaw / yaw_max)*width+middle[0];
       y = (pitch / pitch_max)*height+middle[1];
       //console.log(" right " + right_outer[0] + " left " + left_outer[0] + " x " + x + " y " + width + " middle " + middle[0] + " yaw " + yaw + "calc " + ((yaw / yaw_max)*width));     
       ret = {'success':true,'x': x,'y': y, 'height': height, 'width': width, 'yaw': yaw, 'pitch': pitch};  
       ret['image_eye_distance'] = face.scaledMesh[447][0] - face.scaledMesh[227][0];
       ret['nose_x'] = face.scaledMesh[4][0];  
       ret['nose_y'] = face.scaledMesh[4][1]; 
       ret['widthpct'] = (ret['image_eye_distance']/pictureWidth);
       ret['nosepct_x'] =  (ret['nose_x']/pictureWidth);
       ret['nosepct_y'] = (ret['nose_y']/pictureHeight);
    
       return(ret);
  }
  function trans(name,text='') {
    if (name == '') {
      return(name);
    }
    const element = document.getElementById(name);
    if (element !== undefined && element != null) {
      const val = element.value;  
      if (val != '') {
        text = val;     
      }      
    } else {
      if (name != '' ) {
        text = name;
      } else if (text != '') {
        text = name;
      }
    }
    return(text);
  }
  
  function showAlert(name,reloadReason,reloadText,timeout) {
    document.getElementById("ModalAlertHeadline").innerHTML = trans("scan.alert.alertheadline");
    document.getElementById("ModalAlertText").innerHTML = trans(name);
    modalAlert.style.display = "block";  
    document.getElementById('okAlertButton').addEventListener("click", ()=> {
      modalAlert.style.display = "none";
      reloadURL(reloadReason,trans(reloadText),timeout);
    });
  }

  function showLinked() {
    document.getElementById('nextStepLinked').addEventListener("click", ()=> {
      showReferral();
    });
    modalStepLinked.style.display = "grid";  

  }
  
  function showReferral() { 
      document.getElementById('referralStart').addEventListener("click", ()=> {
        
        let shareData = {
              title: trans("scan.message.sharetitle"),
              text: trans("scan.message.sharetext"),
              url: "https://themagic5.com?&utm_source=referral&utm_medium=affiliate&utm_campaign=after_scan&referral=" + order_id,
            };
        navigator.share(shareData);
        const baseURL = url + '/appconnect.php';
        const myUrl = new URL(baseURL);
        myUrl.searchParams.append('task', 'registerReferrar');
        myUrl.searchParams.append('order_id', order_id); 
        myUrl.searchParams.append('email', email);        
        const aUrl = myUrl.toString();
        $.ajax({
            url:aUrl,
            method: 'GET',
            success: function(response){
              reloadURL(C_REASON_ORDER_CONNECTED,"",0);
            },
            error: function(error){
              console.log(error);
              log("Email: " + email + ". did not register referral" + error);
              reloadURL(C_REASON_ORDER_CONNECTED,"",0);
            }
        });
      });
      document.getElementById('noReferralClicked').addEventListener("click", ()=> {
        reloadURL(C_REASON_ORDER_CONNECTED,"",0);
      });
      if (phone_type != 'iPhone' && phone_type != 'iPad') {
        var androidimglink = "https://cdn.shopify.com/s/files/1/2625/0944/files/share-android.png?v=1701851777";
        document.getElementById("referralStart").src = androidimglink;
      }
      modalStepLinked.style.display = "none";
      modalReferral.style.display = "grid"; 
  }
  
  function showMessage(name,text) {
    document.getElementById("perf").innerHTML = "<p>" + trans(name,text) + "</p>";
  }
  function showMessageWithNumber(name,text,numberText) {
    document.getElementById("perf").innerHTML = "<p>" + trans(name,text) + "</p><p>" + numberText + "</p>";
  }  
  function showAction(name,text) {
    document.getElementById("action").innerHTML = trans(name,text);
  }
  function showCounter(name,text) {
    document.getElementById("counter").innerHTML = trans(name,text);
  }
  
  function analyzeImage(canvas) {
    //return(0);
    //cv = window.cv;
    // Convert the canvas image to an OpenCV matrix
    const srcMat = cv.imread(canvas);
  
    // Convert the image to grayscale
    const grayMat = new cv.Mat();
    cv.cvtColor(srcMat, grayMat, cv.COLOR_RGBA2GRAY);
  
    // Calculate the brightness of the image
    const mean = cv.mean(grayMat);
  
    // Threshold to detect strong background light
    const threshold = 128; // Adjust as needed
    //const hasStrongLightBackground = mean.val[0] > threshold;
    console.log(mean);
    // Display the result
    //console.log(`Mean brightness: ${mean.val[0]}`);
    //console.log(`Has Strong Light Background: ${hasStrongLightBackground}`);
  
    // Clean up
    srcMat.delete();
    grayMat.delete();
    return(mean[0]);
  }  
  function takeSizingImage() {
    showMessage("scan.message.sizinganalyzed",'<p>Sizing image is being analyzed. Please wait.</p>');   
    phase = C_PHASE_CLOSE_SIZE;
    document.getElementById("sizingdiv").style.visibility="hidden";
    canvas.toBlob(function(blob){
        sendSizingImage(blob,function(data) {
          log("Sizing image has been closed successfully sent.");
        });
    },'image/png'); 
  }
feetchecked = false;

  function checkFeet(fileData) {
      if (feetchecked == true) {
        return;
      } 
      feetchecked = true;
      const reader = new FileReader();
        reader.readAsDataURL(fileData);
        reader.onloadend = () => {
          const image = reader.result;
          fetch("https://detect.roboflow.com/foot-detection-azayi/1", {
            method: 'POST',
            params: {
              api_key: "xzAgZRtTeXr8DB1KKGXK"
            },
            data: image,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            
          }).then((response) => {
            console.log(response);
            console.log(response.data);         
            return(true);      
          })      
          .catch((error) => {
            console.log(error); 
            console.log(response.data); 
            // log(`Was not able to initialize. Error: $(error)`,"E");
            // showAlert("scan.alert.nocommunication",C_REASON_NO_COMMUNITATION,"Not able to communicate with the server.",0); 
          }); 
      };   
 
  }
  // Draws the current eyes onto the canvas, directly from video streams
  async function drawFace(face){
      var completion = 0;
      allowed_diff = 20;
      ctx.fillStyle = 'blue';
      sendImageCount = 0;
      const faceContents = getSection(face);
      const x = faceContents['x'];
      const y = faceContents['y'];
      if (window.orientation != 0) {
        phase = C_PHASE_NOTHING;
        showMessage("scan.message.portrait","Please put your phone in portrait mode.");
        document.getElementById("againdiv").style.visibility="visible";
      }
      showHole(faceContents);
      canvas.toBlob(function(blob){
        checkFeet(blob);
      },'image/png'); 
      switch (phase) {
        case C_PHASE_CALIBRATING:
          if (reloadReason == C_REASON_PERFORMANCE_ISSUE1) { 
            phase = C_PHASE_PREPARE_SCAN_CHECK_CAMERA;  
          } else {
            var fps = 1/(.001*(performance.now()-now));
          
            fpsnum += 1;
            if (fpsnum > 5) {
              fpssum += fps;
            }
            var fpsavg = fpssum /(fpsnum-5);          
            // log("Calculating W: " + pictureWidth + " H: " + pictureHeight + " fps " + fps + " fpsavg: " + fpsavg + " fpsnum: " + fpsnum);        
            if ((fpsavg < C_FPS_LIMIT_MIN) && fpsnum > C_FPS_NUMBER && pictureWidth > C_FPS_LOW_WIDTH) {
              document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.calibratingchange","Starting the scanning process") + "</p>";
  
              fpsnum = 0;
              fpssum = 0;            
              inScanningLoop = false;
              var resolutionDecrease = fpsavg/C_FPS_LIMIT_MIN;
              if (resolutionDecrease < 0.8) {
                resolutionDecrease = 0.8;
              }
              log("Returning to main W: " + pictureWidth + " H: " + pictureHeight + " fps: " + fpsavg + " fpsnum: " + fpsnum + " res: " + resolutionDecrease);            
              main(resolutionDecrease); 
              cleanup();            
              //phase = C_PHASE_CALIBRATING;
              phase = C_PHASE_PREPARE_SCAN_CHECK_CAMERA;
              modalLoader.style.display = "none";
              document.getElementById("loadermsg").innerHTML = "";

              
              return;
            } else if ((fpsavg >= C_FPS_LIMIT_MIN && fpsnum > C_FPS_NUMBER) || pictureWidth <= C_FPS_LOW_WIDTH ) {
              phase = C_PHASE_PREPARE_SCAN_CHECK_CAMERA;
              modalLoader.style.display = "none";
              document.getElementById("loadermsg").innerHTML = "";  
            } else if (fpsnum <= C_FPS_NUMBER) {
              document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.calibrating","Starting the scanning process") + "</p>";    
            }
          }
          break;
        case C_PHASE_PREPARE_SCAN_CHECK_CAMERA:
          cameraAnalysisStatus = C_CAMERA_ANALYSIS_STARTED;
          phase = C_PHASE_PREPARE_SCAN_CHECK_POSITION;
          canvas.toBlob(function(blob){
              checkCamera(blob,function(data) {
                cameraAnalysisStatus = C_CAMERA_ANALYSIS_COMPLETED;
            });
          },'image/png');       
          break;
        case C_PHASE_PREPARE_SCAN_CHECK_POSITION:
          // Was 15 and 20        
          if (faceContents['yaw'] > C_FACE_YAW_MAX || faceContents['yaw'] < C_FACE_YAW_MIN || faceContents['pitch'] > C_FACE_PITCH_MAX || faceContents['pitch'] < C_FACE_PITCH_MIN) {
            showMessage("scan.message.eyelevel","Keep your phone at eye-level");
          } else if (faceContents['nosepct_x'] < C_FACE_NOSEPCT_X_MIN) {
            showMessage("scan.message.moveright","Cover the oval shape with your face.");
          } else if (faceContents['nosepct_x'] > C_FACE_NOSEPCT_X_MAX) {   
            showMessage("scan.message.moveleft","Cover the oval shape with your face.");
          } else if (faceContents['widthpct'] < C_FACE_WIDTHPCT_MIN) {       
            showMessage("scan.message.movecloser","Cover the oval shape with your face."); 
          } else if (faceContents['widthpct'] > C_FACE_WIDTHPCT_MAX) {       
            showMessage("scan.message.moveaway","Cover the oval shape with your face.");
          } else {          
            showMessage("");
            countDown(3,C_PHASE_SCAN,"scan.message.starting","Starting scanning in"); 
            log("Scan process: Calibrated: " + order_id,"E")
            startProgress();
          }          
          break;
        case C_PHASE_SCAN:
          var bluepoints = 0;
          var whitepoints = 0;
          for (const[i,pt] of face.scaledMesh.entries()){
              if (mesh_color[i] === undefined && face.mesh[i][0] < (x + allowed_diff) && face.mesh[i][0] > (x - allowed_diff) && face.mesh[i][1] < (y + allowed_diff) && face.mesh[i][1] > (y - allowed_diff) ) {
                  mesh_color[i] = 'blue';
                  sendImageCount += 1;
              }
              if (mesh_color[i] === undefined) {
                whitepoints += 1;
              } else {
                bluepoints += 1;
              }
          }
          globalCompletion = Math.round(100*bluepoints/(bluepoints+whitepoints)); 
          if (globalCompletion > 35) {
            showMessageWithNumber("scan.message.movecolordotswithcompletion","Move your head to color the dots.","Completed: " + globalCompletion + "%");
          } else {
            showMessage("scan.message.movecolordots","<p>Move your head very slowly around to color the dots. </p>");            
          }
          if (sendImageCount > 1) {
              canvas.toBlob(function(blob){
                  image_array.push(blob);
                  landmark_array.push(face.mesh);
                  scaledlandmark_array.push(face.scaledMesh);
              },'image/png');
              sendImageBool = false;
          }
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'white';
          for (const[i,pt] of face.scaledMesh.entries()){
            if (pt[2] < 20) {
              ctx.fillStyle = 'white';
              if (mesh_color[i] !== undefined) {
                  ctx.fillStyle = mesh_color[i];
              }
              ctx.beginPath();
             
              ctx.ellipse(pt[0], pt[1], 5*resolution, 5*resolution, 0, 0, 2*Math.PI)
              ctx.fill();
            }
          }
          break;
        case C_PHASE_PREPARE_SIZE:
          phase = C_PHASE_PREPARE_SIZE_WAIT;
          stepOneComplete.style.display = 'block';          
          setTimeout(()=>{
            stepOneComplete.style.display = 'none';  
            modalStepTwo.style.display = "block"; 
            phase = C_PHASE_PREPARE_SIZE_WAIT;
          }, 1500)  
          break;
        case C_PHASE_PREPARE_SIZE_WAIT:
          break;
        case C_PHASE_START_SIZE:
          showMessage("scan.message.positioncreditcard","Position a credit card sized card on your forehead.");
          setTimeout(function() {
            showMessage("scan.message.positioncreditcardandsubmit",'Position a credit card sized card on your forehead. Press SUBMIT when you are ready.'); 
            document.getElementById("sizingdiv").style.visibility="visible";
          }, 3000); 
          phase = C_PHASE_SIZE;
          break;
        case C_PHASE_SIZE:      
          // var card = findCard();
          var card = false;
          if (card['hasCreditCard'] == true) {
            showMessage("scan.message.cardistheresubmit","Card is there, press SUBMIT.");          
          } else {
            showMessage("scan.message.positioncreditcard",'Position a credit card sized card on your forehead.');  
          }
          break;
        case C_PHASE_CLOSE_SIZE:
          showHole(faceContents);          
          var completePercentage = Math.round(100*(numberOfUploads+numberOfUploadsInitiated) / (image_array.length*2));
          var thirdDigit = String(Math.round(completePercentage/10));
          showMessage("scan.message.analyzingscanandsize" + thirdDigit,"Analyzing the scan and the size.");           
          showCounter("<p>" + completePercentage + "%</p>");
          break;        
        case C_PHASE_CLOSING:
          showHole(faceContents);          
          if (uploadingStatus == C_UPLOADING_COMPLETED) {
            log("Scan process: Uploaded: " + order_id ,"E");
            if (order_id != '') {
              showMessage("scan.message.analysiscompletedwithorder","Analysis completed.");
              phase = C_PHASE_CONNECTING;
              var finished = updateOrderWithScanID(order_id,SCAN_id);
            } else {
              phase = C_PHASE_NOTHING;
              showMessage("scan.message.analysiscompleted","Analysis completed.");
              showProducts();
            }
          } else {
            var completePercentage = Math.round(100*(numberOfUploads+numberOfUploadsInitiated) / (image_array.length*2));
            var thirdDigit = String(Math.round(completePercentage/10));
            showMessage("scan.message.analyzing" + thirdDigit,"Analyzing the scan.");             
            showCounter("<p>" + completePercentage + "%</p>");
          }
          break;
        case C_PHASE_CONNECTING:
          showHole(faceContents);
          break;           
        case C_PHASE_CONNECTED:
          showHole(faceContents);
          
          stepTwoComplete.style.display = 'block';          
          setTimeout(()=>{
            modalStartScan.style.display = "none";
            stepTwoComplete.style.display = 'none'; 
            showLinked();
            /*
            if (testing) {
              showLinked();             
            } else {
              showAlert("scan.alert.scanconnected",C_REASON_ORDER_CONNECTED,"scan.alert.scanconnected",0);
            }  */
          }, 1500)  
          phase = C_PHASE_NOTHING;          
          break; 
        case C_PHASE_PURCHASED:
          
          break; 
        case C_PHASE_NOTHING:
          
          break;          
        case C_PHASE_RESTARTING:
          
          break;  
        case C_PHASE_ERROR:
          cleanup();
          break;           
        default:
          break;
      }
    //console.log("phase " + phase + " number " + image_array.length);
    return(completion);
  }

  function showHole(faceContents) {
    var factor = 1;
    if (faceContents['widthpct'] > C_FACE_WIDTHPCT_MAX) {
      factor = (1-C_FACE_WIDTHPCT_MAX)*faceContents['widthpct'];
    } else if (faceContents['widthpct'] < C_FACE_WIDTHPCT_MIN) {
      factor = (5*(faceContents['widthpct']-0.5)); 
      if (factor > 1) {
        factor = 1;
      }
    }
    const second = Math.round(255*factor);
    const first = Math.round(Math.abs(second-255));
    // log("widthpct is " + faceContents['widthpct'] + " Factor is " + factor + "first " + first + " second " + second);          
    document.getElementById('hole').style.BoxShadow = "0 0 0 9999px rgba(" + first + "," + second + ", 165, " + C_SCAN_OPACITY + ")";   
    document.getElementById('hole').style.webkitBoxShadow = "0 0 0 9999px rgba(" + first + "," + second + ", 165, " + C_SCAN_OPACITY + ")"; 
    document.getElementById('hole').style.mozBoxShadow = "0 0 0 9999px rgba(" + first + "," + second + ", 165, " + C_SCAN_OPACITY + ")";
    // log("yaw " + faceContents['yaw'] + " pitch " + faceContents['pitch']);

    //document.getElementById("iris").style.transform = "translateX(" + 2*faceContents['yaw'] + "px) translateY(" + 2*faceContents['pitch'] + "px) "; // skewX(15deg) skewY(-10deg) scale(0.95)";    
    //document.getElementById('upbow').style.display = "none";     
    /*  height: 1px; 
      top: 40%;
      left: 0px;
      border: solid 5px #000;
      border-color: #000 transparent transparent transparent;
      border-radius: 70%/1px 1px 0 0;  */
  }
  
  function countDown(i,nextStatus,name,nextMessage) {
    if (nextStatus == C_PHASE_CALIBRATING) {
      numberOfRestarts += 1;
    }
    if (numberOfRestarts == 4) {
      phase = C_PHASE_SCAN;
      nextMessage = 'Starting scan in 3 seconds.';
      i = 3;
    } else {
      phase = C_PHASE_NOTHING;
    }
    cameraAnalysisStatus = C_CAMERA_ANALYSIS_NOT_STARTED;
    numberOfUploads = 0;
    image_array = [];
    landmark_array = [];
    scaledlandmark_array = [];
    for(var n=0; n<468; n++){
      mesh_color[n] = undefined;
    }
    setTimeout(function() {
        countDownInternal(i,nextStatus,nextMessage);
    }, 1);  
  }  
  function countDownInternal(i,nextStatus,nextMessage) {
    showMessage("");
    showMessage(nextMessage);
    showCounter("<p>" + i + "</p>");
    i -= 1;
    if (i >= 0) {
      setTimeout(function() {
          countDownInternal(i,nextStatus,nextMessage);
      }, 1000); 
    } else {
      phase = nextStatus;
      nextMessage = '';
      showMessage("");
      showCounter("");
      showAction("");
    }
  } 
  function countDownInitialization(i) {
    countDownInitializationStopIndicator = false;
    setTimeout(function() {
        countDownInitializationInternal(i);
    }, 1);  
  }  
  function countDownInitializationInternal(i) {
    if (countDownInitializationStopIndicator == false) {
      document.getElementById("loadercounter").innerHTML = ("<p>" + i + "</p>");
      i -= 1;
      if (i >= 0) {
        setTimeout(function() {
            countDownInitializationInternal(i);
        }, 1000); 
      } else {
        countDownInitializationStop();
      }
    }
  }  
  function countDownInitializationStop() {
    countDownInitializationStopIndicator = true;
    document.getElementById("loadermsg").innerHTML = '';
    document.getElementById("loadercounter").innerHTML = '';
    showCounter("");    
  }
  function cleanup() {
    cameraAnalysisStatus = C_CAMERA_ANALYSIS_NOT_STARTED;
    numberOfUploads = 0;
    image_array = [];
    landmark_array = [];
    scaledlandmark_array = [];
    for(var n=0; n<468; n++){
      mesh_color[n] = undefined;
    }
    nextMessage = '';
    showMessage("");
    showCounter("");
    showAction("");   
    phase = C_PHASE_NOTHING;
    globalCompletion = 0;
    // modalStartScan.style.display = "block";
  }

  function reloadURL(reasonCode,text,wait) {
      cleanup();
      showMessage(text); 
      next_page = curr_page;  
      if(curr_page.indexOf("?") == -1) {
          next_page = curr_page + '?reload=1';
      }  
      if (reasonCode != C_REASON_NO_REASON && reasonCode != C_REASON_ORDER_CREATED) {
          next_page = next_page+"&reason="+reasonCode;
      }
        if (reasonCode == C_REASON_PERFORMANCE_ISSUE1) {
          next_page = next_page+"&resolution="+resolution;
      } 
      /*if (order_id != '') {
          next_page = next_page+"&order_id="+order_id;          
      }*/
      if (wait > 0) {
        setTimeout(function() {
            window.location.replace(next_page);
        }, wait);          
      } else {
        window.location.replace(next_page);
      } 
  }           
    
  async function main(resolutionChange = 1) {

      pictureHeight =  Math.round(pictureHeight*resolutionChange);
      pictureWidth = Math.round(pictureWidth*resolutionChange);
      if (resolutionChange == 1) {
        modalLoader.style.display = "block";
        // countDownInitialization(3);
        document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.startup1","Starting the scanning process") + "</p>";
      }  
      const urlSearchParams = new URLSearchParams(window.location.search);

      fmesh = await facemesh.load({detectionConfidence:0.8, smoothLandmarks: true, maxFaces:1});
      if (resolutionChange == 1) {    
        document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.startup2","Starting the scanning process") + "</p>";
        //countDownInitializationStop();
      }
    // Set up front-facing camera
      await setupCamera();
      videoWidth = video.videoWidth;
      videoHeight = video.videoHeight;
      if (resolutionChange == 1) {      
        document.getElementById("loadermsg").innerHTML = "<p>" + trans("scan.message.startup3","Starting the scanning process") + "</p>";
      }
      video.play()
      //console.log(" video height " + videoHeight + " video width " + videoWidth);
      // HTML Canvas for the video feed
      canvas = document.getElementById('facecanvas');

      canvas.width = videoWidth;
      canvas.height = videoHeight;    
      ctx = canvas.getContext('2d');
      if (resolutionChange == 1) {        
        initialize();    
      }
      inScanningLoop = true;
      drawVideo();    
      renderPrediction();  
      countDownInitializationStop();
      //modalLoader.style.display = "none";  

  }
  
  function startProgress() {
    return;
    const progressBarContainer = document.querySelector('.progress-bar__container');
    const progressBar = document.querySelector('.progress-bar');
    const progressBarText = document.querySelector('.progress-bar__text');
    progressBarContainer.style.display = "block";
    gsap.to(progressBar, {
      x: `1%`,
      duration: 2,
    });
  }
  function setProgress(state) {
    return;
    const progressBarContainer = document.querySelector('.progress-bar__container');
    const progressBar = document.querySelector('.progress-bar');
    const progressBarText = document.querySelector('.progress-bar__text'); 
    progressBarText.innerHTML = Math.round(state) + '% completed';
    gsap.to(progressBar, {
      x: `${state}%`,
      duration: 2,
      backgroundColor: '#4895ef',
      onComplete: () => {
        progressBarText.style.display = "initial";
        progressBarContainer.style.boxShadow = '0 0 5px #4895ef';
      }
    });
    
  }
  function endProgress() {
    const progressBarContainer = document.querySelector('.progress-bar__container');
    progressBarContainer.style.display = "none";
  }  
  
  function findCard() {
      //cv = window.cv;
      var ret = {'hasCreditCard': false, 'rect': {}};
      const src = cv.imread("facecanvas"); // Load image from canvas
      const dst = new cv.Mat();
      const gray = new cv.Mat();
  
      cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY); // Convert to grayscale
      cv.threshold(gray, gray, 128, 255, cv.THRESH_BINARY); // Threshold to binarize
  
      const contours = new cv.MatVector();
      const hierarchy = new cv.Mat();
  
      cv.findContours(
          gray,
          contours,
          hierarchy,
          cv.RETR_EXTERNAL,
          cv.CHAIN_APPROX_SIMPLE
      );
  
      const aspectRatioThreshold = 1.6; // Adjust this threshold as needed
  
      for (let i = 0; i < contours.size(); i++) {
          const contour = contours.get(i);
          const rect = cv.boundingRect(contour);
  
          // Calculate the aspect ratio (width / height)
          const aspectRatio = rect.width / rect.height;
  
          // Compare the aspect ratio to the threshold
          if (Math.abs(aspectRatio - aspectRatioThreshold) < 0.05 && rect.width > 100) {
            ret['hasCreditCard'] = true;
            ret['rect'] = rect;
            break;
          }
      }
      
      src.delete();
      dst.delete();
      gray.delete();
      hierarchy.delete();
      contours.delete();
      return(ret);
  }
  function hasStrongLightBackground() {
    // cv = window.cv;
    const srcMat = cv.imread("facecanvas"); // Load image from canvas
  
    // Convert the image to grayscale
    const grayMat = new cv.Mat();
    cv.cvtColor(srcMat, grayMat, cv.COLOR_RGBA2GRAY);
  
    // Calculate the brightness of the image
    const mean = cv.mean(grayMat);
  
    // Threshold to detect strong background light
    const threshold = 150; // Adjust as needed
    const hasStrongLightBackground = mean[0] > threshold;
  
    // Display the result
    console.log(`Mean brightness: ${mean[0]}`);
    console.log(`Has Strong Light Background: ${hasStrongLightBackground}`);
  
    // Clean up
    srcMat.delete();
    grayMat.delete();
    return(hasStrongLightBackground);
  } 

  function showOrders(email = '') {
    var div;
    var divimage;
    var status;
    modalScan.style.display = "none";
    modalLoader.style.display = "block";
    let inputOrder = formOrder.querySelector("input");
    if (email == '') {
      email = inputOrder.value ;
    }
    if (email == '') {
        modalScan.style.display = "block";
        modalLoader.style.display = `none`;
        document.querySelector('.text-advice.text-center').textContent = trans("validorderemail","Use valid order email");
    } else {
      $.ajax({
          url:`https://themagic5.com/tools/appconnect/appconnect.php?language=${language}&secret=${secret}&searchstring=${email}&task=getOrdersV2&unique_id=${getUUID()}`,
          method: 'GET',
          success: function(response){
            var data = response.data.data1;
            if(data){
              
                log(data);
                sessionStorage.setItem("email",email);
                $('.container-orders').empty();
                modalLoader.style.display = "none";
                data.forEach((product)=>{
                    status = product.stat;
                    const div = document.createElement('div');
                    div.className = 'orderItem';
                    if (status == '2') {
                      if (product.product_url != '') {
                        const divimage = document.createElement('div'); 
                        divimage.style = 'position: relative;';                      
                        const img2 = document.createElement('img');
                        // img2.className = 'scan_image';
                        img2.src = `https://themagic5.com/tools/appconnect/orderimage.php?id=${product.scan_id}&UUID=${UUID}&secret=${secret}`;
                        img2.style = 'position: absolute; bottom: -100px, left:-100px, height: 100px !important; width: 100px;';
                        img2.alt = 'Order Image';
                        divimage.append(img2);                       
                        const img = document.createElement('img');
                        img.src = product.product_url;
                        img.alt = 'Product Image';
                        divimage.append(img);
                        
                        div.append(divimage);                     
                      } else {
                        const img2 = document.createElement('img');
                        img2.src = `https://themagic5.com/tools/appconnect/orderimage.php?id=${product.scan_id}&UUID=${UUID}&secret=${secret}`;
                        img2.alt = 'Order Image';
                        div.append(img2);                    
                      }
                      
                      const p2 = document.createElement('p');
                      p2.textContent = product.pair;
                      p2.className = 'product-order';
                      div.append(p2);
      
                      const p1 = document.createElement('p');
                      p1.textContent = product.date;
                    
                      const button = document.createElement('button');
                      button.className = 'button_alert openscan';
                      
                      if (product.status == '1') { 
                        if (product.scanstatus <= 8) {    
                          p1.textContent = trans("scan.message.scanreceived","SCAN RECEIVED");
                        } else { 
                          p1.textContent = trans("scan.message.scanbeingvalidated","SCAN IS BEING VALIDATED");
                        }
                      } else if (product.status == '3') {
                        p1.textContent = trans("scan.message.readyforproduction","READY FOR PRODUCTION");                      
                      } else if (product.status == '5') {
                        p1.textContent = trans("scan.message.produced","PRODUCED");                      
                      } else if (product.status == '6') {
                        p1.textContent = trans("scan.message.shipped","SHIPPED");                      
                      } else if (product.status == '7') {
                        p1.textContent = trans("scan.message.delivered","DELIVERED");                      
                      } else if (product.scanstatus == '11') {                       
                        p1.textContent = trans("scan.message.error","SCAN IN ERROR"); 
                        
                      } 
                      button.setAttribute("shopify_url",`${product.shopify_url}`);
                      button.setAttribute("shopify_order_number",`${product.shopify_order_number}`);                      
                      button.setAttribute("order_id",`${product.order_id}`);                      
                      if (product.status == '1' && product.scanstatus <= 8) { 
                        button.onclick = function(){
                          order_id = button.getAttribute("order_id");  
                          shopify_order_number = button.getAttribute("shopify_order_number");                           
                          log("Order ID for re-scanning selected to be: " + order_id);                          
                          modalStepOne.style.display = "block"; 
                          log("Scan process: Intro - Try again: " + order_id,"E");
                          modalOrder.style.display = "none";
                        } 
                        button.textContent = trans("scan.message.receivedtryagain","ORDER DETAILS"); 
                      } else {
                        if (button.getAttribute("shopify_url") != '') {
                          button.onclick = function(){
                            var shopify_url = button.getAttribute("shopify_url");                      
                            sessionStorage.setItem('orderConfirmationPurpose', 'showOrderConfirmation');
                            window.open(shopify_url,"_self");
                          } 
                          button.textContent = trans("scan.message.orderdetails","ORDER DETAILS"); 
                        } else {
                          button.style.display = "none";                           
                        }
                      }                    
                      p1.className = 'date';
                      div.append(p1);
                      div.append(button);                    
                    } else {
                      const img = document.createElement('img');
                      img.src = product.product_url;
                      img.alt = 'Order Image';
                      div.append(img);
                    
                      const p2 = document.createElement('p');
                      p2.textContent = product.pair;
                      p2.className = 'product-order';
                      div.append(p2);
      
                      const p1 = document.createElement('p');
                      p1.textContent = product.date;
                      p1.className = 'date';
                      div.append(p1);
                    
                      const button = document.createElement('button');
                      button.textContent = trans("scan.message.startscan","START SCAN");
                      button.className = 'button_alert openscan';
                      // unique id to control every status in the order products
                      button.setAttribute("order_id",`${product.order_id}`);
                      button.setAttribute("order_ids",`${product.order_ids}`);
                      button.setAttribute("shopify_order_number",`${product.shopify_order_number}`);                      
                      if (product.order_ids === undefined) {
                        button.onclick = function(){
                          console.log(" orders for a single order " + $('.openscan').attr("order_id"));
                          order_id = button.getAttribute("order_id");
                          shopify_order_number = button.getAttribute("shopify_order_number"); 
                          oneScan.setAttribute("shopify_order_number",button.getAttribute("shopify_order_number"));
                          oneScan.setAttribute("order_id",button.getAttribute("order_id"));                    
                          modalStepOne.style.display = "block"; 
                          log("Scan process intro - Try : " + order_id,"E");
                          modalOrder.style.display = "none";
                        } 
                      } else {
                        button.onclick = function(){
                          console.log(" orders for single: " + button.getAttribute("order_id") + " and various " + button.getAttribute("order_ids"));
                          oneScan.setAttribute("order_id",button.getAttribute("order_ids"));
                          oneScan.setAttribute("shopify_order_number",button.getAttribute("shopify_order_number"));
                          variousScan.setAttribute("order_id",button.getAttribute("order_id"));   
                          variousScan.setAttribute("shopify_order_number",button.getAttribute("shopify_order_number"));
                          modalScanOptions.style.display = "block";
                          modalOrder.style.display = "none";
                        } 
                      }                   
                      div.append(button);
                    }
                    $('.container-orders').append(div);
                  })
                  modalOrder.style.display = "block";
                }else{
                    modalScan.style.display = "block";
                    modalLoader.style.display = `none`;
                    document.querySelector('.text-advice.text-center').textContent = trans("validorderemail","Use valid order email");
                }
                window.scrollTo(0,0);
                if (window.registerEmail) {
                  registerEmail(email);
                }
          }
      })
    }  
  }
  
  function showProducts() {
      modalLoader.style.display = "block";
      aUrl = url + '/appconnect.php?task=getDefaultPriceV2';
      $.ajax({
          url:aUrl,
          method: 'GET',
          success: function(response){
            var data = response.data.data1;
            if(data){
                $('.container-products').empty();
                modalLoader.style.display = "none";
                data.forEach((product)=>{
                    const div = document.createElement('div');
                    div.className = 'orderItem';
  
                    const img = document.createElement('img');
                    img.src = product.url;
                    img.alt = 'Order Image';
                    div.append(img);
  
                    const p2 = document.createElement('p');
                    p2.textContent = product.title;
                    p2.className = 'product-order';
                    div.append(p2);
  
                    const p1 = document.createElement('p');
                    p1.textContent = 'Price: ' + product.price + ' ' + product.currency;
                    p1.className = 'date';
                    div.append(p1);
  
                    const button = document.createElement('button');
                    button.textContent = "PURCHASE";
                    button.className = 'button_alert openscan';
                    // unique id to control every status in the order products
                    button.setAttribute("shopify_variant_identifier",`${product.shopify_variant_identifier}`); 
                    button.onclick = function(){
                      var shopify_variant_identifier = button.getAttribute("shopify_variant_identifier");                      
                      modalScanOptions.style.display = "none";
                      sessionStorage.setItem('orderConfirmationPurpose', 'completePurchase');
                      checkoutHandle = window.open("https://themagic5.com/cart/" + shopify_variant_identifier + ":1?pass=APPORDERlocale=" + language + "&note=APPORDER " + SCAN_id,"_self");
                    }                
                    div.append(button);
                    $('.container-products').append(div);
                })
                modalProducts.style.display = "block";
  
            } else {
              showAlert("An error occurred getting the pricing information on products. Please try again later or contact: contact@themagic5.com",C_REASON_NO_REASON,"",0);

          }
        }
      })
  }  

  function log(text,type="I",process='scanapp') {
    if (['E','BIPA'].includes(type) || globalDebug) {
      const baseURL = url + '/appconnect.php';
      const myUrl = new URL(baseURL);
      myUrl.searchParams.append('task', 'putLog');
      myUrl.searchParams.append('source', process); 
      myUrl.searchParams.append('process','App');
      if (shopify_order_number != '') {
        myUrl.searchParams.append('id',shopify_order_number);
      }
      
      if (shopify_order_number != '') {
        text = shopify_order_number.toString() + ": " + text;
      }
      myUrl.searchParams.append('msg', text);   
      const aUrl = myUrl.toString();
      $.ajax({
          url:aUrl,
          method: 'GET',
          success: function(response){
          }
      });
    } 
    console.log(text);      

  }
  window.onerror = function (error, source, lineno, colno, error2) {
    let errortext = error.toLowerCase();
    if (errortext.includes("context lost") && contextLostError == false) {
      contextLostError = true;
      if (reloadReason == C_REASON_PERFORMANCE_ISSUE1) {
        showAlert("alert.message.notabletocalibrate",C_REASON_NOTHING,"",0);
      } else {
        showAlert("scan.message.webglcontextlost",C_REASON_PERFORMANCE_ISSUE1,"",0);          
      } 
    }
    if (lineno != 0 && source != '') {
      log("AppError: " + error + " lineno " + lineno + " source " + source,'E');
    }
  }


// })